import React from "react";

const TestCaseList = ({ testCases = [], onAdd, onEdit, onDelete }) => (
  <div className="cqb-tc-list">
    <div className="cqb-tc-header">
      <h6 className="cqb-tc-title">Test Cases</h6>
      <button type="button" className="cqb-tc-add-btn" onClick={onAdd}>
        + Add Test Case
      </button>
    </div>
    {testCases.length === 0 ? (
      <div className="cqb-tc-empty">No test cases yet. Add one to get started.</div>
    ) : (
      <div className="cqb-tc-table-wrap">
        <table className="cqb-tc-table">
          <thead>
            <tr>
              <th className="cqb-tc-th cqb-tc-col-num">#</th>
              <th className="cqb-tc-th">Input</th>
              <th className="cqb-tc-th">Expected Output</th>
              <th className="cqb-tc-th cqb-tc-col-hidden">Hidden</th>
              <th className="cqb-tc-th cqb-tc-col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {testCases.map((tc, idx) => (
              <tr key={tc._id} className="cqb-tc-row">
                <td className="cqb-tc-td cqb-tc-col-num">{idx + 1}</td>
                <td className="cqb-tc-td">
                  <pre className="cqb-tc-pre">{tc.input || <span className="cqb-tc-empty-val">(empty)</span>}</pre>
                </td>
                <td className="cqb-tc-td">
                  <pre className="cqb-tc-pre">{tc.expectedOutput}</pre>
                </td>
                <td className="cqb-tc-td cqb-tc-col-hidden">
                  <span className={`cqb-tc-badge ${tc.isHidden ? "cqb-tc-badge--hidden" : "cqb-tc-badge--visible"}`}>
                    {tc.isHidden ? "Hidden" : "Visible"}
                  </span>
                </td>
                <td className="cqb-tc-td cqb-tc-col-actions">
                  <button type="button" className="cqb-tc-btn cqb-tc-btn--edit" onClick={() => onEdit(tc)}>Edit</button>
                  <button type="button" className="cqb-tc-btn cqb-tc-btn--delete" onClick={() => onDelete(tc._id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export default TestCaseList;
